<template>
<!-- <transition name="fade"> -->
  <div v-if="showMessage" class="notification-wrapper" @click="dismiss">
    <div class="vue-notification-template vue-notification" :class="status">
      <div class="notification-title">{{title}}</div>
      <div class="notification-content">{{content}}</div>
    </div>
    

    <!-- <transition name="fade">
      <div v-if="showMessage">
        <div class="ui message" :class="status">
          <i class="close icon" @click="dismiss"></i>
          <div class="header">{{content}}<div>
          <p></p>
        </div>
      </div>
      </div>
      </div>
    </transition>-->
  </div>
  <!-- </transition> -->
</template>

<script>
import { eventBus } from '@/main.js';

export default {
  name: "Message",
  props: {
    title: String,
    content: String,
    status: String
  },
  mounted() {
    this.init();
  },
  data() {
    return {
        showMessage: 0
    }
  },
  methods: {
    dismiss() {
        this.showMessage = 0;
    },
    init() {
        eventBus.$on('statusMessage', objMsg => {
            this.showMessage = 1;
            setTimeout(() => (this.showMessage = 0), 4500);
        })
    }
  }
};
</script>
<style scoped>
/* transition for fading */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
  z-index: 0;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

